<ac-card>
  <ac-card-content class="ac-flex ac-flex-col ac-gap-lg ac-ctr ac-width-full">
    @if (status() === 'none') {
      <app-purchase-dialog-header
        title="Account Verification Required"
        (close)="close.emit()"
        (back)="goBack()"
      />

      <img alt="kyc-image" class="kyc-image" width="100" height="100" src="https://cdn.ripabet.com/images/kyc.webp" />
      <div class="ac-label ac-body-md">You have reached your purchase limit. Verify now to instantly unlock higher purchase limits.</div>
    }

    @if (status() === 'approved') {
      <app-purchase-dialog-header
        title="Verification Complete"
        (close)="close.emit()"
        (back)="goBack()"
      />

      <div class="ac-label ac-body-md">Your account has successfully been verified.</div>
    }

    @if (status() === 'rejected') {
      <app-purchase-dialog-header
        title="Verification Failed"
        (close)="close.emit()"
        (back)="goBack()"
      />

      <div class="ac-label ac-body-md">Your account verification has failed.</div>
    }

    @if (status() === 'pending') {
      <app-purchase-dialog-header
        title="Verification In Progress"
        (close)="close.emit()"
        (back)="goBack()"
      />

      <div class="ac-label ac-body-md">Your verification attempt is currently processing. You will receive a notification when your verification is complete.</div>
    }
    <div class="purchase-dialog ac-flex ac-flex-col ac-gap-lg ac-ctr ac-width-full">
      <app-kyc-wizard
        [autoContinueOnApproved]="true"
        [fullWidthButtons]="true"
        [largeButtons]="true"
        (statusChange)="onStatusChange($event)"
        (verifyLater)="close.emit()"
        (continue)="continue.emit()">
      </app-kyc-wizard>
    </div>
  </ac-card-content>
</ac-card>
